import React from 'react';
import { Card, IconButton, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import BasePopover from '../popover/base-popover.component';
import { ViewColumn } from '@mui/icons-material';
import './scss/toolbar-popover.scss';
import _ from 'lodash';
import { HeadCell } from './table.component';

/**
 * 动态列表列
 */
export default function ViewColumnPopover(props: {
    columns: HeadCell[];
    checkedColumnList: string[];
    changeCallback: (checkedColumnList: string[]) => void;
}) {

    const { columns, changeCallback, checkedColumnList } = props;

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleChange = (id: string, checked: boolean) => {
        const newCheckedList = checkedColumnList;
        if (checked) {
            newCheckedList.push(id);
        } else {
            _.pull(newCheckedList, id);
        }
        changeCallback([...newCheckedList]);
    }

    return (
        <>
            <IconButton onClick={(e) => { setAnchorEl(e.currentTarget) }}><ViewColumn /></IconButton>
            <BasePopover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                id='toolbar-view-column-popover'
            >
                <Card style={{ padding: '16px 24px 16px 24px' }} >
                    <FormGroup>
                        {columns.map((item) => {
                            return (
                                <FormControlLabel
                                    key={item.id}
                                    control={
                                        <Checkbox size='small' checked={checkedColumnList.includes(item.id)} onChange={(e) => handleChange(item.id, e.target.checked)} />
                                    }
                                    label={item.label}
                                />
                            )
                        })}
                    </FormGroup>

                </Card>
            </BasePopover >
        </>
    )
}
export type FillterSelects = {
    title: string;
    key: string;
    value: string[];
    optionValues: {
        label: string;
        value: string;
    }[];
}